import * as React from 'react';
import { getBexApiContext } from 'bernie-context';
import { Store } from 'bernie-core';
import { BexApiProvider } from '@shared-ui/bex-api-context';
import { PlatformContextProvider } from '@bernie/platform-context';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * @param context The baseline context info to populate a Bernie app
 */
var ContextStore = /** @class */ (function (_super) {
    __extends(ContextStore, _super);
    /**
     * Constructs a new store from a `Context` object.
     *
     * @param context The raw platform context data.
     * @param logger Bernie logger
     */
    function ContextStore(context, logger) {
        var state = __assign({}, context);
        if (Object.prototype.hasOwnProperty.call(state, 'guid')) {
            delete state.guid;
        }
        return _super.call(this, state, logger) || this;
    }
    Object.defineProperty(ContextStore.prototype, "guid", {
        get: function () {
            return this.deviceId;
        },
        set: function (arg) {
            /*noop*/
        },
        enumerable: false,
        configurable: true
    });
    ContextStore.prototype.hydrate = function (data) {
        Object.assign(this, data);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ContextStore.prototype.toJSON = function (ignoreAdditionalKeys) {
        return _super.prototype.toJSON.call(this, 'remoteAddress');
    };
    return ContextStore;
}(Store));

var getExperienceApiProvider = function (options, appData) {
    var experienceApiContext = appData.experienceApiContext;
    if (experienceApiContext && options.enableExperienceApiProvider !== false) {
        return function (_a) {
            var children = _a.children;
            return React.createElement(BexApiProvider, { context: experienceApiContext }, children);
        };
    }
    return function (_a) {
        var children = _a.children;
        return children;
    };
};

var getPlatformContextProvider = function (options, appData) {
    if (options.enablePlatformContextProvider !== false) {
        return function (_a) {
            var children = _a.children;
            return (React.createElement(PlatformContextProvider, { context: appData.context }, children));
        };
    }
    return function (_a) {
        var children = _a.children;
        return children;
    };
};

function ContextPlugin(pluginOptions) {
    if (pluginOptions === void 0) { pluginOptions = {}; }
    return {
        name: 'context',
        onBrowserHydrateRenderContext: function (pluginContext, next) {
            var hydratedState = pluginContext.hydratedState, setAppData = pluginContext.setAppData, logger = pluginContext.logger;
            var ctx = hydratedState.context;
            var context = new ContextStore(ctx, logger);
            var experienceApiContext = getBexApiContext(context);
            setAppData({ context: context, experienceApiContext: experienceApiContext });
            return next(pluginContext);
        },
        onBrowserWrapRootElement: function (pluginContext, next) {
            var getAppData = pluginContext.getAppData, setRootElement = pluginContext.setRootElement;
            var appData = getAppData();
            var PlatformContextProvider = getPlatformContextProvider(pluginOptions, appData);
            var ExperienceApiProvider = getExperienceApiProvider(pluginOptions, appData);
            setRootElement(function (RootElement) { return function (props) { return (React.createElement(PlatformContextProvider, null,
                React.createElement(ExperienceApiProvider, null,
                    React.createElement(RootElement, null, props.children)))); }; });
            return next(pluginContext);
        },
    };
}

export { ContextPlugin as default };
//# sourceMappingURL=browser.js.map
